import React, { useState } from "react";
import SupportFAQ from "../Models/SupportFAQ";
import QuestionHeader from "./QuestionHeader";

interface Props {
  questionList: readonly SupportFAQ[];
  showCategoryNames: boolean;
}

function QuestionsWrapper({ questionList, showCategoryNames = false }: Props) {
  const [selectedQuestion, setSelectedQuestion] = useState<number>();

  const handleClick = (id: number) => {
    if (selectedQuestion === id) {
      setSelectedQuestion(undefined);
    } else {
      setSelectedQuestion(id);
    }
  };

  const getQuestionHierarchy = () => {
    const mappedFAQs: Map<string, SupportFAQ[]> = new Map([]);

    return questionList.reduce((final, current) => {
      const currentCategoryName = current.categoryName ?? "empty";
      if (final.has(currentCategoryName)) {
        const x = final.get(currentCategoryName);
        x?.push(current);
      } else {
        final.set(currentCategoryName, [current]);
      }
      return final;
    }, mappedFAQs);
  };

  return (
    <div className="support-faq-listing support-section px-5 lt:px-0">
      {Array.from(getQuestionHierarchy()).map((data) => (
        <QuestionHeader
          key={data[0]}
          categoryName={data[0] ?? "empty"}
          showCategoryNames={showCategoryNames}
          questionList={data[1]}
          onClick={handleClick}
          selectedQuestion={selectedQuestion}
        />
      ))}
    </div>
  );
}

export default QuestionsWrapper;
